const binding = { modules: {}, dataActions: {} };

    (binding.modules['dobbies-maintenance'] = {
        c: () => require('partner/modules/dobbies-maintenance/dobbies-maintenance.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dobbies-maintenance',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dobbies-maintenance'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dobbies-maintenance|dobbies-maintenance'] = {
                c: () => require('partner/modules/dobbies-maintenance/dobbies-maintenance.view.tsx'),
                cn: '__local__-__local__-dobbies-maintenance'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };